import {each} from 'lodash';

class bookingMultiController {
	constructor($bookings,
	            $translates,
	            $rootScope,
	            $uibModal,
	            $scope) {

		'ngInject';

		this.$bookings = $bookings;
		this.target = 'working';
		this.$rootScope = $rootScope;
		this.$scope = $scope;

    this.routes         = $bookings.collections.routes;
    this.vehicleBodies  = $bookings.collections.vehicleBodies;

		this.bookings = [];
		this.booking = this.resolve.items.booking;
		this.count = this.resolve.items.count;
		this.returnRoute = this.resolve.items.returnRoute;

		if (!this.count || this.count <= 0) {
			this.count = 1;
		}

		for (let i = 0; i <= this.count-1; i++) {
			this.bookings.push(Object.assign({}, this.booking));
		}

		this.ETVehicleWidth = [
      { value: 7.49, label: 'Poniżej 7,5m' },
      { value: 13, label: 'Pomiędzy 7,5 a 13m' },
      { value: 19, label: 'Powyżej 13m' },
    ];

    this.tunnelVehicleWidth = [
      { value: 10, label: 'Do 10 m' },
      { value: 18.75, label: 'Do 18,75 m'},
    ];

	}

	$onSetTime(index){
    $('#dropdown' + index).parent().removeClass('open');
  }

  beforeRender ($view, $dates) {
    const minDate = window.moment().startOf($view).valueOf(),
          maxDate = window.moment().add(14, 'days').startOf($view).valueOf();
    angular.forEach($dates, function(date) {
        const localDateValue = date.localDateValue();
        date.selectable = localDateValue >= minDate && localDateValue <= maxDate;
    });
	}

	getSelectedVehicleBody(booking) {
    if (booking && booking.route && booking.route.operator && booking.vehicle_type) {
      return this.vehicleBodies[booking.route.operator].find(vb => vb.id === booking.vehicle_type.id);
    } else {
      return null;
    }
  }

  getVBLengthRange(booking) {
    const vb = this.getSelectedVehicleBody(booking);
    return {
      min: vb && vb.minLength || 0,
      max: vb && vb.maxLength || 22
    }
  }

  onVehicleBodyChange(booking) {
		const vb = this.getSelectedVehicleBody(booking);
    booking.vehicle_length = vb.length || vb.minLength;
    booking.weight = vb.weight;
  }

	$onClose($event) {
		$event.preventDefault();
		this.close({$value: 'cancel'});
	}

	$onSubmit(formBookingMulti, $event){

		const data = angular.copy(this.bookings);

		data.map(booking => {

			  booking = this.$bookings.updateTallinkData(booking);
				booking = this.$bookings.adjustDepartureDate(booking, booking.route);
    		booking.route = booking.route.uri;
    		booking.vehicle_type = booking.vehicle_type.name;

    		if (typeof booking.vehicle_length === 'object') {
					booking.vehicle_length = booking.vehicle_length.value;
				}

    		// booking.departure_date = window.moment(booking.departure_date)
				// 	.set({ hour: 0, minute: 0 })
				// 	.format();
    });

		if (this.returnRoute) {
			data.forEach(booking => {
				const route = this.routes.find(r => r.uri === booking.route);
				const returnBooking = Object.assign({}, booking);
				returnBooking.route = route.return_route;
				data.push(returnBooking);
			})
		}

    this.$bookings.multiCreate(data, null,  false)
      .then(() => this.$onClose($event))
      .finally(() => formBookingMulti.$submitted = false );
  }

	get showHours() {
    return this.bookings[0] && this.bookings[0].route && this.bookings[0].route.schedule && !this.bookings[0].route.silent_schedule;
  }

	cleanString(val, removeLetters = false) {
    let output = val.trim().replace(/\s/g, "").replace(/-/g, "")
    return removeLetters ? output.replace(/\D/g,'') : output;
  }


}


export default bookingMultiController;


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-multi/booking-multi.controller.js
 **/